import React, { useState } from 'react'
import '../Styles/StartAnewCareer.css'
import { START_NEW_CAREER_DATA } from '../utils/constants'
import CategoryCard from '../reusable/CategoryCard'

const StartAnewCareer = () => {
  const [categoryIndex,setCategoryIndex]=useState(0)
  // console.log(sessionStorage)
  return (
    <div className='start-heading-container'>
        <h2 className='start-heading'>Start a new career within six months.</h2>
        <div className='category-li'>{
          START_NEW_CAREER_DATA.map((item,index)=>(<div key={item.id} className={categoryIndex===index? 'category-li-item-active':'category-li-item'} onClick={()=>setCategoryIndex(index)}>{item.id}</div>))
          }
        </div>
        <div className='category-cards-container'>
          {START_NEW_CAREER_DATA[categoryIndex].cards.map((item)=>(<CategoryCard {...item} key={item.id}/>))}
            
        </div>
    </div>
  )
}

export default StartAnewCareer